import request from '@/utils/request.js'

// 设计师面料代购订单 - 发起下单
export const CreateDesignDaigouOrder = function (data) {
  return request.post('/design-daigou-order/create', data)
}
// 我的代购订单列表
export const GetDesignDaigouOrderList = function (data) {
  return request.get('/design-daigou-order/lists', data)
}
// 订单详情
export const GetDesignDaigouOrderDetail = function (data) {
  return request.get('/design-daigou-order/detail', data)
}
// 取消订单
export const CancelDesignDaigouOrder = function (data) {
  return request.post('/design-daigou-order/cancel', data)
}
// 发起支付（wechat / alipay / balance）
export const PayDesignDaigouOrder = function (data) {
  return request.post('/design-daigou-order/pay', data)
}
